export const companyBrandedFrame = () => ({
  id: 'company-branded-frame',
  name: 'Company Branded Frame',
  thumbnail: '/assets/diploma-templates/07_frame.webp',
  data: {
    elements: [],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/07_background.svg',
      key: null
    }
  }
});
